import { render, staticRenderFns } from "./profiles.vue?vue&type=template&id=d3e3c4a8"
import script from "./profiles.vue?vue&type=script&lang=js"
export * from "./profiles.vue?vue&type=script&lang=js"
import style0 from "./profiles.vue?vue&type=style&index=0&id=d3e3c4a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./profiles.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports